import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-[#FBF7F4]" data-id="element-41">
      <div className="max-w-4xl mx-auto text-center" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white p-8 md:p-16 rounded-2xl shadow-xl shadow-[#8B7355]/10 border border-[#8B7355]/10" data-id="element-43">
          <h2 className="text-3xl md:text-5xl font-serif text-[#2D2A26] mb-6" data-id="element-44">
            Recupera el control hoy
          </h2>

          <p className="text-lg text-[#2D2A26]/70 mb-10 max-w-xl mx-auto" data-id="element-45">
            Si hoy estás en el ciclo de: <br data-id="element-46" />
            <span className="font-medium text-[#C4A08A]" data-id="element-47">
              rojez → brote → compras → irritación → más rojez…
            </span>{' '}
            <br data-id="element-48" />
            PIEL EN PERI te da el orden correcto.
          </p>

          <a href="#producto" className="w-full md:w-auto bg-[#C4A08A] hover:bg-[#B08D79] text-white text-lg px-10 py-5 rounded-sm font-medium transition-all duration-300 flex items-center justify-center gap-3 mx-auto shadow-lg shadow-[#C4A08A]/30 hover:shadow-xl hover:-translate-y-1" data-id="element-49">
            Entrar al Protocolo
            <ArrowRight className="w-5 h-5" data-id="element-50" />
          </a>

          <p className="mt-6 text-sm text-[#8B7355] uppercase tracking-widest font-medium" data-id="element-51">
            Acceso inmediato • PDF Descargable
          </p>

          <div className="mt-12 pt-10 border-t border-gray-100" data-id="element-52">
            <div className="flex flex-col items-center gap-4" data-id="element-53">
              <ShieldCheck className="w-8 h-8 text-[#8B7355]" data-id="element-54" />
              <div className="max-w-md" data-id="element-55">
                <h3 className="font-serif text-lg text-[#2D2A26] mb-2" data-id="element-56">
                  Garantía de tranquilidad
                </h3>
                <p className="text-sm text-[#2D2A26]/60 leading-relaxed" data-id="element-57">
                  "Si en 7 días no te sientes más en control (menos caos, más
                  claridad de qué te irrita), escribe y te devuelvo el dinero."
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}